/**
 * Loads the product page's recommendation blocks as soon as the page is idle, instead of when they
 * come near the screen.
 *
 * Horizon's `product-recommendations` element (assets/product-recommendations.js) fetches only when
 * an IntersectionObserver sees it, 400px before it scrolls into view. On a long product page that
 * means a fast scroller reaches an empty strip, waits for the request, and watches the content
 * pop in and push everything below it down. The same element reloads on any attribute change other
 * than its own bookkeeping ones, so touching a data attribute starts that fetch early without
 * changing the component. Once it has loaded, further changes are ignored by it.
 *
 * Covers "Customers also bought" and "Complete the perfect pair". Skipped in the theme editor,
 * which renders sections itself.
 */
function prefetch() {
  if (window.Shopify?.designMode) return;

  document.querySelectorAll('product-recommendations.oudh-recs, product-recommendations.oudh-pair').forEach((element) => {
    if (element.getAttribute('data-recommendations-performed') === 'true') return;
    element.setAttribute('data-prefetch', '');
  });
}

function whenIdle() {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(prefetch, { timeout: 3000 });
  } else {
    window.setTimeout(prefetch, 1500);
  }
}

if (document.readyState === 'complete') {
  whenIdle();
} else {
  window.addEventListener('load', whenIdle, { once: true });
}
